// extracted by mini-css-extract-plugin
export default {"lesson_card":"lesson_card__R4fIe","lesson_icon":"lesson_icon__W+D-l"};